import { render, staticRenderFns } from "./DashboardSixMonthlySafetyV2.vue?vue&type=template&id=715b1aa8&"
import script from "./DashboardSixMonthlySafetyV2.vue?vue&type=script&lang=js&"
export * from "./DashboardSixMonthlySafetyV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports